import React, { useEffect, useState } from "react";
import TypeApi from "../../api/TypeApi";
import SourceApi from "../../api/SourceApi";
import GroupApi from "../../api/GroupApi";
import UserApi from "../../api/UserApi";
import StateApi from "../../api/StateApi";
import LeadFinalApi from "../../api/leadFinalApi";
import { showSuccess, showError } from "../../utils/toastUtils";

function AssignLead({ data, onSuccess }) {
  const [typeList, setTypeList] = useState([]);
  const [sourceList, setSourceList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [managerList, setManagerList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);

  const [form, setForm] = useState({
    typeId: "",
    sourceId: "",
    groupId: "",
    stateId: "",
    state: "",
    district: "",
    pincode: "",
    managerId: "",
  });

  useEffect(() => {
    loadMasters();
    loadStates();
  }, []);

  /* ================== LOAD MASTERS ================== */
  // const loadMasters = async () => {
  //   const [t, s, g, u] = await Promise.all([
  //     TypeApi.list(),
  //     SourceApi.list(),
  //     GroupApi.list(),
  //     UserApi.list(),
  //   ]);

  //   if (t.code === 200) setTypeList(t.data);
  //   if (s.code === 200) setSourceList(s.data);
  //   if (g.code === 200) setGroupList(g.data);

  //   if (u.code === 200) {
  //     const managers = u.data.filter(
  //       (x) => x.roleId && x.roleId?.role?.toLowerCase() === "manager"
  //     );

  //     setManagerList(managers);
  //   }
  // };

  const loadMasters = async () => {
    try {
      const [t, s, g, u] = await Promise.allSettled([
        TypeApi.list(),
        SourceApi.list(),
        GroupApi.list(),
        UserApi.salesUsers(),
      ]);

      if (t.status === "fulfilled" && t.value.code === 200) {
        setTypeList(t.value.data || []);
      }

      if (s.status === "fulfilled" && s.value.code === 200) {
        setSourceList(s.value.data || []);
      }

      if (g.status === "fulfilled" && g.value.code === 200) {
        setGroupList(g.value.data || []);
      }

      if (u.status === "fulfilled" && u.value.code === 200) {
        console.log("SALES USERS =>", u.value.data);

        setManagerList(u.value.data || []);
      } else {
        console.error("Sales users API failed");
        setManagerList([]);
      }
    } catch (err) {
      console.error("Master loading failed:", err);
      setManagerList([]);
    }
  };

  /* ================== STATES ================== */
  const loadStates = async () => {
    const res = await StateApi.getStates();
    if (res.code === 200) setStateList(res.data);
  };

  /* ================== DISTRICTS (BY STATE ID) ================== */
  const loadDistricts = async (stateId) => {
    if (!stateId) return;
    const res = await StateApi.getDistrictsByState(stateId);
    if (res.code === 200) setDistrictList(res.data);
    else setDistrictList([]);
  };

  /* ================== CHANGE ================== */
  const handleChange = (e) => {
    const { name, value } = e.target;

    // ✅ State selection
    if (name === "stateId") {
      const selectedState = stateList.find((s) => s._id === value);

      setForm((p) => ({
        ...p,
        stateId: value,
        state: selectedState?.name || "",
        district: "",
      }));

      loadDistricts(value);
      return;
    }

    setForm((p) => ({ ...p, [name]: value }));
  };

  /* ================== SUBMIT ================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.managerId) {
      return showError("Please select user");
    }

    const payload = {
      ...form,
      assignedLeads: data,
    };
    delete payload.stateId;

    Object.keys(payload).forEach((k) => payload[k] === "" && delete payload[k]);

    try {
      const res = await LeadFinalApi.assignBulk({
        managerId: form.managerId,
        leadIds: data,
      });

      if (res.code === 200) {
        showSuccess(res.message);
        document.querySelector("#add-leadassign-modal .btn-close")?.click();
        onSuccess?.();
      } else {
        showError(res.message);
      }
    } catch (err) {
      console.error("Add lead assign failed:", err);
      showError(err?.message || "Something went wrong");
    }
  };

  return (
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Assign Lead</h4>
          <button className="btn-close" data-bs-dismiss="modal" />
        </div>

        <form onSubmit={handleSubmit} className="p-3 row">
          <Select
            col="4"
            label="Type"
            name="typeId"
            list={typeList}
            labelKey="type"
            value={form.typeId}
            onChange={handleChange}
          />
          <Select
            col="4"
            label="Source"
            name="sourceId"
            list={sourceList}
            labelKey="source"
            value={form.sourceId}
            onChange={handleChange}
          />
          <Select
            col="4"
            label="Group"
            name="groupId"
            list={groupList}
            labelKey="group"
            value={form.groupId}
            onChange={handleChange}
          />

          {/* ✅ State ID */}
          <Select
            col="4"
            label="State"
            name="stateId"
            list={stateList}
            labelKey="name"
            value={form.stateId}
            onChange={handleChange}
          />

          {/* ✅ District NAME */}
          <Select
            col="4"
            label="District"
            name="district"
            list={districtList}
            labelKey="name"
            value={form.district}
            onChange={handleChange}
            disabled={!form.stateId}
          />

          {/* ✅ Pincode (District ke right side) */}
          <div className="col-md-4 mb-3">
            <label>Pincode</label>
            <input
              type="text"
              className="form-control"
              name="pincode"
              value={form.pincode}
              onChange={handleChange}
              placeholder="Enter Pincode"
            />
          </div>

          {/* ✅ Manager */}
          <Select
            col="12"
            label="Assign User"
            name="managerId"
            list={managerList}
            labelKey="name"
            value={form.managerId}
            onChange={handleChange}
          />

          <div className="text-end">
            <button className="btn btn-primary">Assign</button>
          </div>
        </form>
      </div>
    </div>
  );
}

/* ================== REUSABLE SELECT ================== */
const Select = ({
  col,
  label,
  name,
  value,
  onChange,
  list,
  labelKey,
  disabled,
}) => {
  console.log("SELECT", name, list);

  return (
    <div className={`col-md-${col} mb-3`}>
      <label>{label}</label>

      <select
        className="form-select"
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        <option value="">Select {label}</option>

        {list &&
          list.length > 0 &&
          list.map((i) => (
            <option key={i._id} value={name === "district" ? i.name : i._id}>
              {name === "managerId" ? i.name : i[labelKey]}
            </option>
          ))}
      </select>
    </div>
  );
};

export default AssignLead;
